module.exports = __webpack_public_path__ + "static/media/avatar4.7b640c5b.jpg";